import { ReactNode } from 'react';
import { Box, Grid, Typography } from '@material-ui/core';
import { EntityScorecardCard } from '../../techInsights/EntityScorecardCard';
import { EntityServiceTierCard } from '../ServiceTier';
import { AboutPanel } from './AboutPanel';
import { OnThisPage } from './OnThisPage';
import { QuickLinks } from './QuickLinks';
import { RelationsFlow } from './RelationsFlow';
import { StatsStrip } from './StatsStrip';
import { useScorecard } from './useScorecard';

/** Cards stacked in one column, each at its natural height. */
const Stack = ({ children }: { children: ReactNode }) => (
  <Box display="flex" flexDirection="column" style={{ gap: 24 }}>
    {children}
  </Box>
);

const Section = ({
  id,
  title,
  children,
}: {
  id: string;
  title: string;
  children: ReactNode;
}) => (
  <Box id={id} style={{ scrollMarginTop: 16 }}>
    <Typography variant="h5" gutterBottom>
      {title}
    </Typography>
    <Stack>{children}</Stack>
  </Box>
);

const SECTIONS = [
  { id: 'about', label: 'About' },
  { id: 'relations', label: 'Relations' },
  { id: 'health', label: 'Health' },
  { id: 'tier', label: 'Service tier' },
];

/** The outline and the entity's links, kept in view while the page scrolls. */
const SideRail = () => (
  <Box position="sticky" top={16}>
    <OnThisPage sections={SECTIONS} />
    <Box mt={3}>
      <QuickLinks />
    </Box>
  </Box>
);

/** The service overview: a summary bar, then About, Relations, Health and Service tier. */
export const ServiceOverview = ({ warnings }: { warnings: ReactNode }) => {
  const scorecard = useScorecard();

  return (
    <>
      <Grid container spacing={3}>
        {warnings}
      </Grid>
      <Box pt={3}>
        <StatsStrip scorecard={scorecard} />
      </Box>
      <Grid container spacing={3}>
        <Grid item xs={12} md={9}>
          <Stack>
            <Section id="about" title="About">
              <AboutPanel />
            </Section>
            <Section id="relations" title="Relations">
              <RelationsFlow />
            </Section>
            <Section id="health" title="Health">
              <EntityScorecardCard />
            </Section>
            <Section id="tier" title="Service tier">
              <EntityServiceTierCard />
            </Section>
          </Stack>
        </Grid>
        <Grid item xs={12} md={3}>
          <SideRail />
        </Grid>
      </Grid>
    </>
  );
};
